import * as React from "react";
import RaisedButton from "material-ui/RaisedButton";
import FlatButton from "material-ui/FlatButton";
import BusyFromPromise from "components/BusyFromPromise";
import {primary, white, success, secondaryText, hover, danger, secondaryDark, primaryDark, disabledBackground} from "../../colors";
import * as cn from "classnames";
import styles = require("./style.less");
import {baseSizeInPx, normal} from "fontWeights";

interface ActionButtonProps {
    label: string;
    busyLabel?: string;
    disabled?: Promise<any> | boolean; // Currently unsupported for Ternary buttons
    type?: ActionButtonType;
    icon?: JSX.Element;
    tabIndex?: number;
    className?: string;
    keyboardFocused?: boolean;
    style?: object;
    labelProps?: any;

    onFocus?(event: React.FocusEvent<HTMLElement>): void;
    onClick?(event: any): Promise<any> | void;
}

interface ActionButtonState {
    invocation?: Promise<any>;
}

export enum ActionButtonType {
    Primary,
    Secondary,
    Ternary,
    Save,
    Delete,
}

export default class ActionButton extends React.Component<ActionButtonProps, ActionButtonState> {
    constructor(props: ActionButtonProps) {
        super(props);
        this.state = {};
    }

    onClick(event: any) {
        if (!this.props.onClick) {
            return;
        }

        if (event.preventDefault) {
            event.preventDefault();
        }
        const promise = (async () => await this.props.onClick(event))();
        this.setState({invocation: promise});
        return promise;
    }

    getButton(busy: boolean, disabled: boolean) {
        const props = this.props;

        const otherProps = {
            tabIndex: props.tabIndex,
            className: cn(styles.globalActionButton, props.className),
        };
        const commonLabelStyle = {
            fontSize: "0.8125rem",
        };
        const labelStyle = {
            color: primary,
            opacity: props.disabled ? 0.5 : 1,
            whiteSpace: "nowrap",
            ...commonLabelStyle,
            ...props.labelProps
        };
        const wrapperStyle = { // wrapper allows margin to be added
            display: "inline-block",
        };

        const label = busy && props.busyLabel ? props.busyLabel : props.label;

        const onClick = disabled ? null : (e: any) => this.onClick(e);

        switch (props.type) {

            case ActionButtonType.Primary:
                return <RaisedButton
                    type="submit"
                    label={label}
                    title={label}
                    disabled={disabled}
                    icon={props.icon}
                    backgroundColor={secondaryDark}
                    labelColor={white}
                    labelStyle={commonLabelStyle}
                    disabledBackgroundColor={disabledBackground}
                    disabledLabelColor={white}
                    onClick={onClick}
                    onFocus={props.onFocus}
                    keyboardFocused={this.props.keyboardFocused}
                    {...otherProps}
                />;

            case ActionButtonType.Save:
                return <RaisedButton
                    type="submit"
                    keyboardFocused={this.props.keyboardFocused}
                    label={label}
                    title={label}
                    disabled={disabled}
                    disabledBackgroundColor={disabledBackground}
                    disabledLabelColor={white}
                    backgroundColor={success}
                    labelColor={white}
                    labelStyle={commonLabelStyle}
                    onClick={onClick}
                />;

            case ActionButtonType.Delete:
                return <RaisedButton
                    type="submit"
                    keyboardFocused={this.props.keyboardFocused}
                    label={label}
                    title={label}
                    disabled={disabled}
                    backgroundColor={danger}
                    labelColor={white}
                    labelStyle={commonLabelStyle}
                    onClick={onClick}
                    disabledBackgroundColor={disabledBackground}
                    disabledLabelColor={white}
                />;

            case ActionButtonType.Ternary:
                const contents = props.icon
                    ? [props.icon, label]
                    : label;
                const height = 36 / baseSizeInPx + "rem";
                return <a href="#"
                          title={label}
                          onClick={onClick}
                          onFocus={props.onFocus}
                          style={{height, lineHeight: height, marginLeft: "0.5rem", marginRight: "0.5rem",
                                  fontSize: "0.8125rem", fontWeight: normal, textTransform: "uppercase"}}
                          {...otherProps}>
                    {contents}
                </a>;

            // Fallthrough to Secondary
            default:
                const style = this.props.style ? this.props.style : {margin: "inherit"};
                // Div allows margin to be added
                return <FlatButton
                    label={label}
                    title={label}
                    labelStyle={labelStyle}
                    style={style}
                    icon={props.icon}
                    disabled={disabled}
                    onClick={onClick}
                    onFocus={props.onFocus}
                    keyboardFocused={this.props.keyboardFocused}
                    {...otherProps}
                />;
        }
    }

    render() {
        return <BusyFromPromise promise={this.state.invocation}>
            {(busy: boolean) => <BusyFromPromise promise={this.props.disabled}>
                {(disabled: boolean) => this.getButton(busy, disabled || busy)}
            </BusyFromPromise>}
        </BusyFromPromise>;
    }
}

export {ActionButton};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Button/ActionButton.tsx